const initialState = { loginUrl: '' };

export default function signIn(state = initialState) {
  return state;
}
